{
  "invalidSelection": "{selectedCount, plural, one {Data} other {Datas}} selecionada(s) indisponível(is)."
}
